<template>
    <div>
        <b-button
            class="button-delete"
            @click.prevent="openModal(attribute)"
            variant="outline-light"
        >
            <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3 6H11V16H3V6ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z"
                    fill="#BEC0C0"
                />
            </svg>
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'TrashToDelete',
    props: ['attribute'],
    methods: {
        openModal(attribute) {
            const h = this.$createElement
            const title = h('div', {
                domProps: {
                    innerHTML: `<h4>${this.$t(
                        'strategy.onepage.newAttribute.delete'
                    )} ${attribute.name ? `"${attribute.name}"` : ''}</h4>`,
                },
            })
            this.$bvModal
                .msgBoxConfirm([title], {
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'primary',
                    okTitle: 'Confirmar',
                    cancelTitle: 'Cancelar',
                    cancelVariant: 'outline-primary',
                    footerClass: 'px-2',
                    hideHeaderClose: false,
                    hideHeader: true,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.$emit('toDelete', attribute)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
}
</script>

<style lang="sass" scoped>
div.button-actions
    div
        div
            margin: 0 !important
.button-delete
    padding: 0
    border: none
.button-delete:hover
    background-color: transparent
</style>
